import { createFileRoute, redirect } from '@tanstack/react-router';
import { FEATURE_FLAGS } from '@vizit/constants';
import { getFeatureFlag } from '@vizit/feature-flags';
import { OpportunityProductsPage } from '../../pages';
import { PagesProvider } from '../../pages/providers/pages-provider';
import { beforeLoadAuthenticatedValidation, guardOrganizationReports } from '../../router';
import { NavbarPageTemplate } from '../../templates';

export const Route = createFileRoute('/_authenticated/reports/opportunity_/products')({
  staticData: {
    pageName: 'Opportunity Report',
  },
  beforeLoad: async ({ context, location }) => {
    await beforeLoadAuthenticatedValidation(context, location);

    const isOpportunityReportEnabled = await getFeatureFlag(FEATURE_FLAGS.OPPORTUNITY_REPORT, false);
    if (!isOpportunityReportEnabled) {
      throw redirect({ to: '/' });
    }

    await guardOrganizationReports(context);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PagesProvider template={NavbarPageTemplate}>
      <OpportunityProductsPage />
    </PagesProvider>
  );
}
